import { action, observable } from "mobx";
import { LoadingStore } from "./loadingStore";
import { CollectionLetterModel, deleteCollectionLetterHistory } from "@/api/LetterHistory";
export class CollectionIssueLetterHistoryEditStore {
  @observable letterHistory: CollectionLetterModel[] = [];
  @observable selectedLetterHistory: CollectionLetterModel | undefined = undefined;
  @observable letterHistoryDeleted = false;
  @observable loading = new LoadingStore();

  @action.bound DeleteSelectedHistory() {
    this.letterHistoryDeleted = true;

    const request = {
      id: this.selectedLetterHistory?.id ?? 0
    };
    return this.loading.track(async () => {
      try {
        await deleteCollectionLetterHistory(request);
      } catch (error) {
        console.log(error);
        throw "";
      }
    }, "DeleteSelectedHistory");
  }
}

const collectionIssueLetterHistoryEditStore = new CollectionIssueLetterHistoryEditStore();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).collectionIssueLetterHistoryEditStore = collectionIssueLetterHistoryEditStore;

export default collectionIssueLetterHistoryEditStore;
